import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type SidebarContentProps = ComponentProps<'div'>;

const SidebarContent = ({ className, ...props }: SidebarContentProps) => {
  return (
    <div
      data-slot="sidebar-content"
      data-sidebar="content"
      className={cn(
        'no-scrollbar flex min-h-0 flex-1 flex-col gap-0 overflow-auto group-data-[collapsible=icon]:overflow-hidden',
        className,
      )}
      {...props}
    />
  );
};

export default SidebarContent;
